export default "__VITE_PUBLIC_ASSET__2d1e1770__"